// Глобальная темная тема для всего приложения
export const darkTheme = {
  colors: {
    // Основные цвета
    background: '#121212',
    surface: '#1E1E1E',
    surfaceVariant: '#242424',
    primary: '#BB86FC',
    secondary: '#03DAC6',
    error: '#CF6679',
    
    // Текст
    textPrimary: '#FFFFFF',
    textSecondary: 'rgba(255, 255, 255, 0.7)',
    textDisabled: 'rgba(255, 255, 255, 0.5)',
    
    // Граница
    border: 'rgba(255, 255, 255, 0.12)',
    
    // Градиенты для карточек
    cardGradient: 'linear-gradient(180deg, rgba(18, 18, 18, 0) 0%, #121212 40%)',
  },
  
  // Тени
  shadows: {
    sm: '0 2px 8px rgba(0, 0, 0, 0.3)',
    md: '0 4px 12px rgba(0, 0, 0, 0.4)',
    lg: '0 8px 24px rgba(0, 0, 0, 0.5)'
  },
  
  // Закругления
  borderRadius: {
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    circle: '50%'
  },
  
  // Типографика
  typography: {
    fontFamily: '"SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h1: {
      fontSize: '36px',
      fontWeight: '700',
      lineHeight: '1.2'
    },
    h2: {
      fontSize: '30px',
      fontWeight: '700',
      lineHeight: '1.3'
    },
    h3: {
      fontSize: '24px',
      fontWeight: '600',
      lineHeight: '1.4'
    },
    body1: {
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '1.5'
    },
    body2: {
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '1.5'
    },
    button: {
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '1.5'
    }
  }
}; 